import { API_v2 } from '@/services/config';
import { request } from '@umijs/max';

/**
 * 获取菜单列表
 * @param params
 * @param options
 */
export async function getMenuList(
  params: {
    platform_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMenuList, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 获取平台列表
 * @param options
 */
export async function getPlatformList(options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.getPlatformList, {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 新增菜单/按钮
 * @param data
 * @param options
 */
export async function addRoutes(
  data: {
    platform_id?: number;
    type?: number;
    parent_id?: number;
    name?: number;
    path?: number;
    component?: number;
    icon?: number;
    status?: number;
    redirect?: number;
    sort?: number;
    permission?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addRoutes, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 编辑菜单
 * @param data
 * @param options
 */
export async function editRoutes(
  data: {
    platform_id?: number;
    type?: number;
    parent_id?: number;
    name?: number;
    path?: number;
    component?: number;
    icon?: number;
    status?: number;
    redirect?: number;
    sort?: number;
    permission?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editRoutes, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除菜单
 * @param data
 * @param options
 */
export async function delRoutes(
  data: {
    id?: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delRoutes, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
